import { AdobeMethods } from '../../../../services/adobe-launch/adobe-launch.methods';
import { AdobePageName } from '../../../../services/adobe-launch/adobe-launch.pages';
import { AdobeAnalyticsProcessStep } from '../../../../services/adobe-launch/adobe-launch.process';
import { AnalyticsCtaType, CtaNames } from '../../../../services/adobe-launch/adobe-launch.cta';

export const configData = {
    adobeInfoOnlyPageLoad: [
        {
            method: AdobeMethods.PAGE_LOAD,
            data: [AdobePageName.GRANTEE_NVG_ALMOST_THERE_PAGE_INFO_ONLY],
        },
    ],
    adobeLimitedPageLoad: [
        {
            method: AdobeMethods.PAGE_LOAD,
            data: [AdobePageName.GRANTEE_NVG_ALMOST_THERE_PAGE_LIMITED],
        },
    ],
    adobeLoginInfoOnly: [
        {
            method: AdobeMethods.TRACK_ACTION,
            data: [
                {
                    location: AdobeAnalyticsProcessStep.NON_VG_CLIENT_ALMOST_THERE_INFO_ONLY,
                    ctaName: CtaNames.LOGIN,
                    ctaType: AnalyticsCtaType.BUTTON,
                },
            ],
        },
    ],
    adobeLoginLimited: [
        {
            method: AdobeMethods.TRACK_ACTION,
            data: [
                {
                    location: AdobeAnalyticsProcessStep.NON_VG_CLIENT_ALMOST_THERE_LIMITED,
                    ctaName: CtaNames.LOGIN,
                    ctaType: AnalyticsCtaType.BUTTON,
                },
            ],
        },
    ],
};